import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import {
  addAllItemToSelectList,
  openNewWindow,
  setDash,
  setDetailPageUrl,
  setNumberWithComma,
} from '../../../../../lib/common';
import Anchor from '../../../../../components/link/Anchor';
import TableFilterSelect from '../../../../../components/_table/TableFilterSelect';
import { POINT_LOG_TYPE_SELECT_LIST, POINT_LOG_TYPE_TEXT } from '../../../../../constants/service/app/pointConstants';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { ACCOUNT_USER_DETAIL_TAB_KEY } from '../../../../../constants/service/app/accountUserConstants';

/**
 *  포인트 발급 내역에 연결된 포인트 로그 리스트 컬럼
 */
export const columns = (props) => {
  const { pointCauseSelectList, filterOption, onFilter } = props;

  return [
    {
      title: <TableColumnTitle title={'회원 번호'} />,
      dataIndex: 'userId',
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() =>
            openNewWindow(
              setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, value) +
                `?tabKey=${ACCOUNT_USER_DETAIL_TAB_KEY.POINT_INFO}`,
            )
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'이름'} />,
      dataIndex: 'userName',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'내역 종류'} />,
      dataIndex: 'type',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={POINT_LOG_TYPE_SELECT_LIST}
          option={filterOption.type}
          confirm={confirm}
          onFilter={(type) => onFilter({ type })}
        />
      ),
      render: (value) => POINT_LOG_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'적립/사용처'} />,
      dataIndex: 'causeName',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(pointCauseSelectList, '적립/사용처 선택')}
          option={filterOption.pointCauseId}
          confirm={confirm}
          onFilter={(pointCauseId) => onFilter({ pointCauseId })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'액수'} />,
      dataIndex: 'amount',
      render: (value) => setNumberWithComma(value, '원'),
    },
  ];
};
